import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { langs } from './config';
i18next
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng:
      langs.find((items) => items.key === localStorage.getItem('langs'))?.abbreviationKey || 'en',
    debug: false,
    load: 'languageOnly',
    supportedLngs: langs.map((items) => items.abbreviationKey),
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: (keys: string[]) => {
        return `${process.env.REACT_APP_PREFIX_HOST}${process.env.REACT_APP_S3_BUCKET}${
          keys[0] == 'pt' ? 'PO' : keys[0].toLocaleUpperCase()
        }.json`;
      },
      allowMultiLoading: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br'],
    },
  });

export default i18next;
